import competitions from 'api/definitions/competitions';

import { COMPETITIONS_FORM_ACTIONS } from 'redux/modules/competitions/actions/types';

export default (
  { optIns, termsAndConditions, onlineOrderNumber, receiptNumber, purchaseType, ...props },
  competitionType,
  competitionId,
  captchaKey,
) => ({
  types: COMPETITIONS_FORM_ACTIONS,
  apiCall: competitions.post({
    body: {
      optIns: optIns
        ? optIns.filter(Boolean).map(optIn => ({
            optInName: optIn,
          }))
        : undefined,
      orderId: purchaseType && purchaseType === 'Online' ? onlineOrderNumber : receiptNumber,
      purchaseType,
      termsAndConditions: termsAndConditions === 'consent',
      captchaKey,
      ...props,
    },
    iHandleStatusCodes: [403, 409],
    competitionType,
    competitionId,
  }),
});
